import { FC, useMemo } from "react";
//#region types
import { WintSalaryEnums } from "models/enums";
import { WintDeviationSelectionViewProps } from "models/propTypes/wintSalaryPropTypes";
import { SearchInputProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelWintSalaryDeviations } from "wint-api-client/dist/types";
//#endregion
//#region components
import { SearchInput, VerticalFormField } from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const WintDeviationSelection: FC<WintDeviationSelectionViewProps> = (props) => {
  const { connect, selectedDeviationType, allDeviationTypes, editMode, onDeviationChange } = props;

  const mapFormDeviationTypetoCategoryType = (deviationType: WintSalaryEnums.SalaryDeviationType) => {
    switch (deviationType) {
      case WintSalaryEnums.SalaryDeviationType.Absence:
        return WintSuperkollAPIModelWintSalaryDeviations.SalaryDeviationTypeCategory.Absence;
      case WintSalaryEnums.SalaryDeviationType.WorkingHours:
        return WintSuperkollAPIModelWintSalaryDeviations.SalaryDeviationTypeCategory.WorkedHours;
      case WintSalaryEnums.SalaryDeviationType.Compensation:
        return WintSuperkollAPIModelWintSalaryDeviations.SalaryDeviationTypeCategory.Compensations;
      case WintSalaryEnums.SalaryDeviationType.TimeBalances:
        return WintSuperkollAPIModelWintSalaryDeviations.SalaryDeviationTypeCategory.TimeBalances;
      default:
        return WintSuperkollAPIModelWintSalaryDeviations.SalaryDeviationTypeCategory.Absence;
    }
  };

  const deviationTypes = useMemo(() => {
    return allDeviationTypes.filter(
      (type) => type.data.category === mapFormDeviationTypetoCategoryType(selectedDeviationType)
    );
  }, [allDeviationTypes, selectedDeviationType]);

  const registrationLableKey = useMemo(() => {
    switch (selectedDeviationType) {
      case WintSalaryEnums.SalaryDeviationType.Absence:
        return TranslationKeys.SalaryDeviation.AbsenceRegistrationLable;
      case WintSalaryEnums.SalaryDeviationType.WorkingHours:
        return TranslationKeys.SalaryDeviation.WorkTimeRegistrationLable;
      case WintSalaryEnums.SalaryDeviationType.Compensation:
        return TranslationKeys.SalaryDeviation.CompensationRegistrationLable;
      case WintSalaryEnums.SalaryDeviationType.TimeBalances:
        return TranslationKeys.SalaryDeviation.TimeBalancesRegistrationLable;
      default:
        return TranslationKeys.SalaryDeviation.AbsenceRegistrationLable;
    }
  }, [selectedDeviationType]);

  //TODO: Add suggestions for the search input based on the selected deviation type
  const deviationConnector = connect("deviation");

  return (
    <VerticalFormField<SearchInputProps>
      Component={SearchInput}
      {...deviationConnector}
      label={LocalizationHelperInstance.getFormattedMessage(registrationLableKey)}
      showMainLabel
      items={deviationTypes}
      disabled={editMode}
      setValue={onDeviationChange ?? deviationConnector.setValue}
    />
  );
};

export default WintDeviationSelection;
